import { PlatformPage } from './PlatformPage'
import { platformFeatures } from '@/data/platform'

export default function DAM() {
  return <PlatformPage feature={platformFeatures['dam']!} />
}
